<template>
<div class="form">
  <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
 <h1 align="center" style="text-decoration: underline overline;">JRD - Pinjaman Kewangan</h1>
 <!-- <h2 align="center" style="text-decoration:">Pinjaman Kewangan</h2> -->

  <v-text-field
    outlined 
    dense
    rounded
    v-model="HID"
    label="HID"
    :rules="rules"
    width="20px"
    disabled
  ></v-text-field>

  

<!-- DATATABLE  -->
<v-card>
      <v-card-title>
          Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataJRD"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
      ></v-data-table>
</v-card>  

<!-- ISI BORANG -->
<v-card>
<v-card-text>
<v-form ref="form" v-model="valid" lazy-validation>

<v-row>
  <v-col class="black--text">
    S143 : Adakah anda mempunyai pinjaman kewangan ?
    
    <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
            return-object
            solo
            dense
            v-model="JRDS143" 
            ></v-autocomplete>
    </v-col>
</v-row>
<v-col v-show="showS144S148">
<v-row>
  
  <v-col cols="6" class="black--text">
    S144 : Perumahan
  </v-col>
</v-row>

<v-row>
  <v-col cols="6" class="black--text">
    i) Adakah anda mempunyai pinjaman kewangan perumahan ?
    
    <v-autocomplete
           :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
            return-object
            solo
            dense
            v-model="JRDS144i" 
             @change="onChangeS144($event)">
    </v-autocomplete>
    </v-col>
</v-row>
<v-col v-show="showS144">
<!-- <v-row>
  <v-col cols="6" class="black--text">  
  ii) Nyatakan tempoh pinjaman kewangan perumahan. <strong>[La(i)]</strong>
  <v-autocomplete
      v-model="Lai"
      outlined 
      min="0"
      maxlength="2"
      :items="tambahlookupbulan"
      type="number"
      dense
      persistent-hint
      hint="Bulan"
      :item-text="item => item.id"
      item-value="id"
      >
  </v-autocomplete>
  </v-col>

  <v-col cols="6" class="black--text">  
  iii) Nyatakan jumlah komitmen bulanan. <strong>[La(ii)]</strong>
  <v-text-field
    v-model="Laii"
      label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Sebulan"
         >
      </v-text-field>
      </v-col> 
</v-row> -->
   

<v-row>
  <v-col cols="6" class="black--text">
    iv) Adakah menerima moratorium ?  
    <!-- Sekiranya jawapan di S144(iv) adalah Ya, S144(v) perlu ada pengisian -->
    
     <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
            return-object
            solo
            dense
            v-model="JRDS144iv" 
            @change="onChangeS144v($event)">
    </v-autocomplete>
    </v-col>

   <!--  <v-col cols="6" class="black--text" v-show="showS144v">  
  v) Tempoh bulan yang diterima. <strong>[LMa]</strong>
  <v-autocomplete
      min="0"
      maxlength="2"
      :items="tambahlookupbulan"
      v-model="LMa"
      outlined 
      type="number"
      dense
      persistent-hint
      hint="Bulan"
      :item-text="item => item.id"
      item-value="id"
      >
  </v-autocomplete>
  </v-col> -->

</v-row>
</v-col>

<!-- S145--->

<v-row>
  <v-col cols="6" class="black--text">
    S145 : Kenderaan bermotor
  </v-col>
</v-row>

<v-row>
  <v-col cols="6" class="black--text">
    i)Adakah anda mempunyai pinjaman kewangan kenderaan bermotor?  
    <!-- Sekiranya jawapan di (i) adalah Ya, maka (ii) -(v) perlu ada pengisian -->
    
     <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
           
            return-object
            solo
            dense
            v-model="JRDS145i" 
             @change="onChangeS145($event)">
    </v-autocomplete>
    </v-col>
</v-row>

<v-col v-show="showS145">
<v-row>
  <!--  <v-col class="black--text">  
         ii) Nyatakan tempoh pinjaman kewangan kenderaan bermotor <strong>[Lb(i)]</strong>
   <v-autocomplete
          v-model="Lbi"
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete> 
   </v-col> -->

<!--    <v-col class="black--text">  
         iii) Nyatakan jumlah komitmen bulanan <strong>[Lb(ii)]</strong>
   <v-text-field
          v-model="Lbii"
           label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Sebulan"
         >
        </v-text-field>
          
   </v-col> -->
</v-row>

<v-row>
   <v-col cols="6" class="black--text">  
         iv)  Adakah menerima moratorium?
         <!-- Sekiranya jawapan di(iv) adalah Ya, maka (v) perlu ada pengisian -->
      
       <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            v-model="JRDS145iv"
            :items="yaTidak"
            return-object
            solo
            dense
            @change="onChangeS145v($event)"
      >
    </v-autocomplete>
   </v-col>

<!--    <v-col class="black--text" v-show="showS145v">  
         v) Tempoh bulan yang diterima <strong>[LMb]</strong>
        <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="LMb"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>
   </v-col> -->
</v-row>
</v-col>
<!-- S146--->


<v-row>
   <v-col class="black--text" >
         S146 :  Pelajaran
  </v-col>                  
</v-row>

<v-row>
  <v-col cols="6" class="black--text">
      i) Adakah anda mempunyai pinjaman kewangan pelajaran?
  <!-- Sekiranya jawapan di S145(i) adalah Ya, maka S146(ii) - S146(v) perlu ada pengisian  -->
    
     <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
           
            return-object
            solo
            dense
      v-model="JRDS146i"
       @change="onChangeS146($event)">
      </v-autocomplete>
  </v-col>
</v-row>
<v-col v-show="showS146">
<!-- <v-row>
  <v-col class="black--text" >
         ii) Nyatakan tempoh pinjaman kewangan pelajaran.<strong>[Lc(i)]</strong>
        <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="Lci"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
        </v-autocomplete>
          
   </v-col>

   <v-col cols="6" class="black--text" >
         iii) Nyatakan jumlah komitmen bulanan <strong>[Lc(ii)]</strong>
        <v-text-field
          v-model="Lcii"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Sebulan"
         >
         </v-text-field>
   </v-col>
</v-row> -->

<v-row>
   <v-col cols="6" class="black--text" >
         iv)  Adakah menerima moratorium?
        <!-- *Sekiranya jawapan di S146(iv) adalah Ya, S146(v) perlu ada pengisian  -->
  <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
           
            return-object
            solo
            dense
     v-model="JRDS146iv"
      @change="onChangeS146v($event)"
      ></v-autocomplete>
   </v-col>

   <!-- <v-col cols="6" class="black--text" v-show="showS146v" >
         v) Tempoh bulan yang diterima <strong>[LMc]</strong>
    <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="Lc"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>
   </v-col> -->
</v-row>
</v-col>
<!-- S147--->


<v-row>
   <v-col class="black--text" >
          S147 : Peribadi
  </v-col>                  
</v-row>

<v-row>
  <v-col cols="6" class="black--text">
      i) Adakah anda mempunyai pinjaman kewangan peribadi?
  <!-- Sekiranya jawapan di S147(i) adalah Ya, maka S147(ii) - S147(v) perlu ada pengisian  -->
      <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
         :items="yaTidak"
          
            return-object
            solo
            dense
            v-model="JRDS147i"
             @change="onChangeS147($event)">
      </v-autocomplete>
  </v-col>
</v-row>
<v-col v-show="showS147">
<v-row>
 <!--   <v-col cols="6" class="black--text" > 
         ii) Nyatakan tempoh pinjaman kewangan peribadi.<strong>[Ld(i)]</strong>
   <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="Ldi"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>   
   </v-col> -->

   <!-- <v-col cols="6" class="black--text" >  
         iii) Nyatakan jumlah komitmen bulanan <strong>[Ld(ii)]</strong>
       <v-text-field
        v-model="Ldii"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Sebulan"
         >
      </v-text-field>
  
          
   </v-col> -->
</v-row>

<v-row>
   <v-col cols="6" class="black--text" >  
         iv)  Adakah menerima moratorium?
         <!-- Sekiranya jawapan di(iv) adalah Ya, (v) perlu ada pengisian -->
  <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
           
            return-object
            solo
            dense
             v-model="JRDS147iv"
              @change="onChangeS147v($event)" >
    </v-autocomplete>
     
     
   </v-col>

  <!--  <v-col class="black--text" v-show="showS147v" >
         v) Tempoh bulan yang diterima <strong>[LMd]</strong>
  <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="LMd"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>
        
     </v-col>    -->
</v-row>
</v-col>
<!-- S148--->


<v-row>
    <v-col class="black--text" >
    S148 : Lain-lain (Contoh : ASB, ASN, dan lain-lain.)
    </v-col>                  
</v-row>

<v-row>
   <v-col cols="6" class="black--text" >
      i) Adakah anda mempunyai pinjaman kewangan lain-lain?
<!-- Sekiranya jawapan di(i) adalah Ya, maka (ii) - (v) perlu ada pengisian  -->
  <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
           
            return-object
            solo
            dense
      v-model="JRDS148i"
       @change="onChangeS148($event)">
  </v-autocomplete>
  </v-col>
</v-row>
<v-col v-show="showS148">
<v-row>
 <!--   <v-col class="black--text" >  
         ii) Nyatakan tempoh pinjaman kewangan lain-lain.<strong>[Le(i)]</strong>
   <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="Lei"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>   
      </v-col> -->

   <!--  <v-col class="black--text" >  
         iii) Nyatakan jumlah komitmen bulanan <strong>[Le(ii)]</strong>
    <v-text-field
          v-model="Leii"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Sebulan"
          >
        </v-text-field>
          
      </v-col> -->
</v-row>

<v-row>
  <v-col cols="6" class="black--text" >  
         iv)  Adakah menerima moratorium?
        <!-- Sekiranya jawapan di S145(iv) adalah Ya, S145(v) perlu ada pengisian -->
  <v-autocomplete
            :item-text="item => item.id +' - '+ item.desc"
            :items="yaTidak"
            
            return-object
            solo
            dense
            v-model="JRDS148iv"
             @change="onChangeS148v($event)" >
    </v-autocomplete>
      </v-col>

  <!--  <v-col class="black--text" v-show="showS148v">   
         v) Tempoh bulan yang diterima <strong>[LMe]</strong>
  <v-autocomplete
          min="0"
          maxlength="2"
          :items="tambahlookupbulan"
          v-model="LMe"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Bulan"
          :item-text="item => item.id"
          item-value="id"
         >
      </v-autocomplete>       
      </v-col> -->

</v-row>
</v-col>
</v-col>
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
        :disabled="checkMandatori()">
      Simpan/Kemaskini
    </v-btn>
     <!-- <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateJRD()"
    >
      Kemaskini
    </v-btn> -->
    <v-btn
      text
      color="primary"
      @click="goTo()"
    >
      Seterusnya
    </v-btn>
</v-card-actions>

</v-form> 
</v-card-text>
</v-card>

<!-- <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert> -->
    
<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>


</div>
</template>
<script>
import axios from '../../plugins/axios'

/////////////////////////////////////////////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
/////////////////////////////////////////////////////////

export default {

   async beforeMount(){

        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

///////////////////////////////lookup table yang diperlukan//////////////////

        this.yaTidak = lookupFieldServices.getYaTidak();
        this.getData();//dapatkan data based on HID

    },
    setup() {
        
    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        yaTidak:[],
        showS144S148: false,
        showS144:false,
        showS145:false,
        showS146:false,
        showS147:false,
        showS148:false,
        showS144v:false,
        showS145v:false,
        showS146v:false,
        showS147v:false,
        showS148v:false,
        butangSimpan: true,
        //butangKemaskini: false,

        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: '',
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:'',
        NOAIR:'',


        JRDS143:[],
        JRDS144i:[],
        // Lai:'',
        // Laii:0,
        JRDS144iv:[],
        // LMa:0,
        JRDS145i:[],
        // Lbi:'',
        // Lbii:0,
        JRDS145iv:[],
        // LMb:0,
        JRDS146i:[],
        // Lci:'',
        // Lcii:0,
        JRDS146iv:[],
        Lc:'',
        JRDS147i:[],
        // Ldi:'',
        // Ldii:0,
        JRDS147iv:[],
        // LMd:0,
        JRDS148i:[],
        // Lei:'',
        // Leii:0,
        JRDS148iv:[],
        LMe:0,
        dataJRD:[],
        rules: [
        value => !!value || 'Required.',
      ],

        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID ', value: 'HID' },
          { text: 'S143 ', value: 'JRDS143' },
          { text: 'S144(i)', value: 'JRDS144i' },
          // { text: 'La(i)', value: 'Lai' }, 
          // { text: 'La(ii)', value: 'Laii' },
          { text: 'S144(iv)', value: 'JRDS144iv' },
          // { text: 'LMa', value: 'LMa' },
          { text: 'S145(i)', value: 'JRDS145i' },
          // { text: 'Lb(i)', value: 'Lbi' },
          // { text: 'Lb(ii)', value: 'Lbii' },
          { text: 'S145(iv)', value: 'JRDS145iv' },
          // { text: 'LMb', value: 'LMb' },
          { text: 'S146(i)', value: 'JRDS146i' },
          // { text: 'Lc(i)', value: 'Lci' },
          // { text: 'Lc(ii)', value: 'Lcii' },
          { text: 'S146(iv)', value: 'JRDS146iv' },
          { text: 'Lc', value: 'Lc' },
          { text: 'S147(i)', value: 'JRDS147i' },
          // { text: 'Ld(i)', value: 'Ldi' },
          // { text: 'Ld(ii)', value: 'Ldii' },
          { text: 'S147(iv)', value: 'JRDS147iv' },
          // { text: 'LMd', value: 'LMd' },
          { text: 'S148(i)', value: 'JRDS148i' },
          // { text: 'Le(i)', value: 'Lei' },
          // { text: 'Le(ii)', value: 'Leii' },
          { text: 'S148(iv)', value: 'JRDS148iv' },
          // { text: 'LMe', value: 'LMe' },
          
          
        ],
       
     ///////////link untuk ke page/////////////////////

      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        // {
        //   text: 'JRB Pindahan Semasa Diterima',
        //   disabled: false,
        //   href: 'JRBpindahan',
        // },
        // {
        //   text: 'JRB Penerimaan Bulan Sebelumnya',
        //   disabled: true,
        //   href: 'IMBANGAN',
        // },
        // {
        //   text: 'JRB Penerimaan one-off',
        //   disabled: false,
        //   href: 'JRB1off',
        // },
        //  {
        //   text: 'JRC Pindahan Semasa Dibayar',
        //   disabled: false,
        //   href: 'JRCPSD',
        // },
        {
          text: 'JRD Pinjaman Kewangan',
          disabled: true,
          href: 'JRD',
        },
     
      ],
     
      select: null,
      checkbox: false,
    }),



    //METHODS

    methods: {
      getUnits: function(a) {
            alert(`${a}`)
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      goTo(){
        if(this.NOAIR == "01"){
          this.$router.push({name: "JRE1"});
        }else{
          this.$router.push({name: "ringkasanMaklumatIR"});
        }
          
      },

      checkMandatori(){
     
     if(this.JRDS143 =="" || this.JRDS144i =="" || this.JRDS145i =="" || this.JRDS146i =="" || this.JRDS147i =="" || this.JRDS148i ==""){
       return true;
       
     }else{
       return false;
     }
    

   },
      onChangeS144(){

        if(this.JRDS144i.id == 1){
          this.showS144 = true;
        }else{
           this.showS144 = false;
           this.JRDS144iv = {"id":"0"};
           
        }

      },

       onChangeS144v(){

        if(this.JRDS144iv.id == 1){
          this.showS144v = true;
        }else{
           this.showS144v= false;
        }

      },

      onChangeS145(){

        if(this.JRDS145i.id == 1){
          this.showS145 = true;
        }else{
           this.showS145 = false;
           this.JRDS145iv = {"id":"0"};
        }

      },

       onChangeS145v(){

        if(this.JRDS145iv.id == 1){
          this.showS145v = true;
        }else{
           this.showS145v= false;
        }

      },

       onChangeS146(){

        if(this.JRDS146i.id == 1){
          this.showS146 = true;
        }else{
           this.showS146 = false;
           this.JRDS146iv = {"id":"0"};
        }

      },

       onChangeS146v(){

        if(this.JRDS146iv.id == 1){
          this.showS146v = true;
        }else{
           this.showS146v= false;
        }

      },

       onChangeS147(){

        if(this.JRDS147i.id == 1){
          this.showS147 = true;
        }else{
           this.showS147 = false;
           this.JRDS147iv = {"id":"0"};
        }

      },

       onChangeS147v(){

        if(this.JRDS147iv.id == 1){
          this.showS147v = true;
        }else{
           this.showS147v= false;
        }

      },

       onChangeS148(){

        if(this.JRDS148i.id == 1){
          this.showS148 = true;
        }else{
           this.showS148 = false;
           this.JRDS148iv = {"id":"0"};
        }

      },

       onChangeS148v(){

        if(this.JRDS148iv.id == 1){
          this.showS148v = true;
        }else{
           this.showS148v= false;
        }

      },
      async simpan (){
         if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
          try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/insertJRD`, {
            
            HID: this.HID,
            NOAIR: this.NOAIR,
            JRDS143: this.JRDS143.id, 
            JRDS144i: this.JRDS144i.id,
            // Lai: this.Lai,
            // Laii: this.Laii,
            JRDS144iv: this.JRDS144iv.id,
            // LMa: this.LMa,
            JRDS145i: this.JRDS145i.id,
            // Lbi: this.Lbi,
            // Lbii: this.Lbii,
            JRDS145iv: this.JRDS145iv.id,
            // LMb: this.LMb,
            JRDS146i: this.JRDS146i.id,
            // Lci: this.Lci,
            // Lcii: this.Lcii,
            JRDS146iv: this.JRDS146iv.id,
            Lc: this.Lc,
            JRDS147i: this.JRDS147i.id,
            // Ldi: this.Ldi,
            // Ldii: this.Ldii,
            JRDS147iv: this.JRDS147iv.id,
            // LMd: this.LMd,
            JRDS148i: this.JRDS148i.id,
            // Lei: this.Lei,
            // Leii: this.Leii,
            JRDS148iv: this.JRDS148iv.id,
            // LMe: this.LMe,


          })
        this.res = res.data
                //this.message = "Data Saved";
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.reset();
                this.getData();
                // setTimeout(() => (this.goTo()), 2000);
               } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }
      },

      async simpan2(){

          try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/insertJRD`, {
            
            HID: this.HID,
            NOAIR: this.NOAIR,
            JRDS143: 0, 
            JRDS144i: 0,
            // Lai: 0,
            // Laii: 0,
            JRDS144iv:0,
            // LMa: 0,
            JRDS145i: 0,
            // Lbi: 0,
            // Lbii: 0,
            JRDS145iv: 0,
            // LMb: 0,
            JRDS146i: 0,
            // Lci: 0,
            // Lcii: 0,
            JRDS146iv: 0,
            Lc:0,
            JRDS147i: 0,
            // Ldi: 0,
            // Ldii: 0,
            JRDS147iv: 0,
            // LMd: 0,
            JRDS148i: 0,
            // Lei: 0,
            // Leii: 0,
            JRDS148iv: 0,
            // LMe: 0,
          })
        this.res = res.data
                //this.message = "Data Saved";
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.reset();
                this.getData();
                this.goTo();
                // setTimeout(() => (this.goTo()), 2000);
               } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
      },

      async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRD/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },

      async getData(){

        //dapatkan data dari table HK1 based on HID

        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getJRD?HID=`+this.HID+`&NOAIR=`+this.NOAIR,{
            })
            var dataz = res.data.data
            this.dataJRD = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }

      },

        handleClick(row) {
          // this.saveButton = true;
          // this.updateButton = false;

          // this.butangSimpan = false;
          // this.butangKemaskini = true;

              this.JRDS143 = this.yaTidak[row.JRDS143 - 1];
              this.JRDS144i = this.yaTidak[row.JRDS144i - 1];
              // this.Lai = row.Lai;
              // this.Laii = row.Laii;
              this.JRDS144iv = this.yaTidak[row.JRDS144iv- 1];
              // this.LMa = row.LMa;
              this.JRDS145i = this.yaTidak[row.JRDS145i- 1];
              // this.Lbi = row.Lbi;
              // this.Lbii = row.Lbii;
              this.JRDS145iv = this.yaTidak[row.JRDS145iv- 1];
              // this.LMb = row.LMb;
              this.JRDS146i = this.yaTidak[row.JRDS146i- 1];
              // this.Lci = row.Lci;
              // this.Lcii = row.Lcii;
              this.JRDS146iv = this.yaTidak[row.JRDS146iv- 1];
              this.Lc = row.Lc;
              this.JRDS147i = this.yaTidak[row.JRDS147i- 1];
              // this.Ldi = row.Ldi;
              // this.Ldii = row.Ldii;
              this.JRDS147iv = this.yaTidak[row.JRDS147iv- 1];
              // this.LMd = row.LMd;
              this.JRDS148i = this.yaTidak[row.JRDS148i- 1];
              // this.Lei = row.Lei;
              // this.Leii = row.Leii;
              this.JRDS148iv = this.yaTidak[row.JRDS148iv- 1];
              // this.LMe = row.LMe;
          

          // or just do something with your current clicked row item data
          //console.log(row)
      },
      
   
    },
    computed:{
      tambahlookupbulan() {
      return lookup.getBulan();
      },


    },
    watch:{
      JRDS143(val){
        if(val.id == 1){
          this.showS144S148 = true;
        }else{
          this.simpan2();
        }
      },
      JRDS144i(val){

        if(val.id == 1){
          this.showS144 = true;
        }else{
           this.showS144 = false;
           //this.Lai = 0;
           //this.Laii = 0;
          //  this.LMa = 0;
           this.JRDS144iv = {"id":"0"};
        }

      },
      JRDS145i(val){
        if(val.id == 1){
          this.showS145 = true;
        }else{
           this.showS145 = false;
          /*  this.Lbi = 0;
           this.Lbii = 0;
           this.LMb = 0; */
           this.JRDS145iv = {"id":"0"}; 
        }

      },
      JRDS146i(val){

        if(val.id == 1){
          this.showS146 = true;
        }else{
           this.showS146 = false;
           /* this.Lci = 0;
           this.Lcii = 0; */
           this.Lc = 0;
           this.JRDS146iv = {"id":"0"};
        }

      },
      JRDS147i(val){
        if(val.id == 1){
          this.showS147 = true;
        }else{
           this.showS147 = false;
          //  this.Ldi = 0;
          //  this.Ldii = 0;
          //  this.LMd = 0;
           this.JRDS147iv = {"id":"0"};
        }
      },
      JRDS148i(val){
        if(val.id == 1){
          this.showS148 = true;
        }else{
           this.showS148 = false;
          //  this.Lei = 0;
          //  this.Leii = 0;
          //  this.LMe = 0;
           this.JRDS148iv = {"id":"0"};
        }

      },

    }
}
</script>
